import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import AutocaptureConfig from '../../libraries/react-native/_snippets/autocapture-config-rn.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In web apps using the PostHog `}<a parentName="p" {...{
        "href": "/docs/libraries/react-native"
      }}>{`React Native SDK`}</a>{`, the following data can be autocaptured.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Application Opened`}</strong>{` - when the app is opened from a closed state`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Became Active`}</strong>{` - when the app comes to the foreground (e.g. from the app switcher)`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Backgrounded`}</strong>{` - when the app is sent to the background by the user`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Installed`}</strong>{` - when the app is installed.`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Updated`}</strong>{` - when the app is updated.`}</li>
      <li parentName="ul"><strong parentName="li">{`$screen`}</strong>{` - when the user navigates (if using `}<inlineCode parentName="li">{`@react-navigation/native`}</inlineCode>{` (v6 or lower) or `}<inlineCode parentName="li">{`react-native-navigation`}</inlineCode>{`), check out the `}<a parentName="li" {...{
          "href": "/docs/libraries/react-native#capturing-screen-views"
        }}>{`capturing screen views`}</a>{` section`}</li>
      <li parentName="ul"><strong parentName="li">{`$autocapture`}</strong>{` - touch events when the user interacts with the screen`}</li>
    </ul>

    <AutocaptureConfig mdxType="AutocaptureConfig" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      